import React, { Fragment } from 'react';
import { AppBar, Box, Grid, IconButton, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import logohome from '../resource/logo-home.svg';
import logozaul from '../resource/logo-azul-texto.svg'
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from 'react-scroll';


const useStyles = makeStyles((theme) => ({

    bar: {
        backgroundColor: 'red',
    },
    logo: {

        maxWidth: '10em',
    },
    menuItems: {
        padding: '0.5em',

        [theme.breakpoints.up('lg')]: {
            padding: '2em'
        },

    },
    menuText: {
    },

    buttons: {
        color: theme.palette.arenco.green
    },
    active: {
        color: theme.palette.arenco.darkBlue
    }

}));


const NavBar = ({ alterBackground, openMenu, menuIsOpen, onClickMenu }) => {

    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <AppBar position="fixed" style={
            alterBackground ?
                {
                    backgroundColor: 'transparent',
                    background: 'transparent',
                    boxShadow: 'none',
                    zIndex: 1100
                }
                :
                {
                    backgroundColor: 'transparent',
                    background: 'transparent',
                    boxShadow: 'none',
                    zIndex: 1100
                }}>
            <Grid container alignItems="center" style={{ marginTop: '1em' }}>


                {
                    matchesSM &&
                    <Grid item >
                        <IconButton size="medium" onClick={() => openMenu()}>
                            <MenuIcon fontSize="large" style={menuIsOpen ? { color: '#b1ded3' } : { color: alterBackground ? '#052443' : '#b1ded3' }} />
                        </IconButton>
                    </Grid>
                }

                {
                    !matchesSM &&
                    <Grid item xs style={{ paddingLeft: '3em' }}>
                        {
                            alterBackground
                                ? <img className={classes.logo} src={logozaul} alt="logo_azul"></img>
                                : <img className={classes.logo} src={logohome} alt="logo_home"></img>
                        }
                    </Grid>
                }


                {
                    !matchesSM &&

                    <Fragment>

                        <Grid item className={classes.menuItems}>
                            <Link style={{ cursor: 'pointer', color: theme.palette.arenco.green }} to="home" spy={true} smooth={true} offset={0} duration={500} delay={0} onClick={() => onClickMenu()}>
                                <Typography variant="h6" className={classes.menuText} style={alterBackground ? { color: theme.palette.arenco.darkBlue } : { color: theme.palette.arenco.green }}>
                                    <Box fontWeight={800} style={{ paddingBotton: '1em' }}>HOME</Box></Typography>
                            </Link>
                        </Grid>
                        <Grid item className={classes.menuItems}>
                            <Link style={{ cursor: 'pointer', color: theme.palette.arenco.darkBlue }} to="lis" spy={true} smooth={true} offset={0} duration={500} delay={0} onClick={() => onClickMenu()}>
                                <Typography variant="h6" className={classes.menuText} style={alterBackground ? { color: theme.palette.arenco.darkBlue } : { color: theme.palette.arenco.green }}><Box fontWeight={800}>LIS</Box></Typography>
                            </Link>
                        </Grid>
                        <Grid item className={classes.menuItems}>
                            <Link style={{ cursor: 'pointer', color: theme.palette.arenco.darkBlue }} to="middleware" spy={true} smooth={true} offset={0} duration={500} delay={0} onClick={() => onClickMenu()}>
                                <Typography variant="h6" className={classes.menuText} style={alterBackground ? { color: theme.palette.arenco.darkBlue } : { color: theme.palette.arenco.green }}><Box fontWeight={800}>MIDDLEWARE</Box></Typography>
                            </Link>
                        </Grid>
                        <Grid item className={classes.menuItems}>
                            <Link style={{ cursor: 'pointer', color: theme.palette.arenco.darkBlue }} to="about" spy={true} smooth={true} offset={0} duration={500} delay={0} onClick={() => onClickMenu()}>
                                <Typography variant="h6" className={classes.menuText} style={alterBackground ? { color: theme.palette.arenco.darkBlue } : { color: theme.palette.arenco.green }}><Box fontWeight={800}>QUIENES SOMOS</Box></Typography>
                            </Link>
                        </Grid>
                        <Grid item className={classes.menuItems} style={{ marginRight: '4em' }}>
                            <Link style={{ cursor: 'pointer', color: theme.palette.arenco.darkBlue }} to="contact" spy={true} smooth={true} offset={0} duration={500} delay={0} onClick={() => onClickMenu()}>
                                <Typography variant="h6" className={classes.menuText} style={alterBackground ? { color: theme.palette.arenco.darkBlue } : { color: theme.palette.arenco.green }}><Box fontWeight={800}>CONTACTO</Box></Typography>
                            </Link>
                        </Grid >

                    </Fragment >


                }




            </Grid >

        </AppBar >
    );
};

export default NavBar;